import React from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../config/appConfig';
import { logout } from '../store/slices/authSlice';
import { getRequiredVerificationRoute, getVerificationDestination } from '../utils/verification';
import BrandLogo from '../components/BrandLogo';
import EmailVerificationPrompt from '../components/auth/EmailVerificationPrompt';
import '../styles/Auth.css';

const EmailVerification = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const requiredRoute = getRequiredVerificationRoute(user);
  if (requiredRoute === ROUTES.phoneVerification) {
    return <Navigate to={requiredRoute} replace state={location.state} />;
  }
  if (!requiredRoute) {
    const destination = getVerificationDestination(user, location.state?.from);
    return <Navigate to={destination.to} replace state={destination.state} />;
  }
  return (
    <main className="auth-page py-5">
      <Container style={{ maxWidth: 520 }}>
        <Card className="p-4 shadow-sm">
          <BrandLogo />
          <h1 className="h3 mt-4">Verify your email</h1>
          <EmailVerificationPrompt email={user?.email || ''}
            description="Complete this required setup step before continuing to orders." />
          <Button variant="link" className="mt-3 align-self-start" onClick={() => dispatch(logout())}>Sign out</Button>
        </Card>
      </Container>
    </main>
  );
};

export default EmailVerification;
